// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__162Mk","largestCol":"styles_largestCol__1dTg4","smallestCol":"styles_smallestCol__2XTVH"};